import { render } from "./cu-header.vue?vue&type=template&id=18837d6e&scoped=true"
import script from "./cu-header.vue?vue&type=script&lang=js"
export * from "./cu-header.vue?vue&type=script&lang=js"

import "./cu-header.vue?vue&type=style&index=0&id=18837d6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18837d6e"]])

export default __exports__